export const quotes = [
  {
    text: "La vita è quello che ti accade mentre sei impegnato a fare altri progetti.",
    author: "John Lennon"
  },
  {
    text: "Il futuro appartiene a coloro che credono nella bellezza dei propri sogni.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "L'unico modo per fare un ottimo lavoro è amare quello che fai.",
    author: "Steve Jobs"
  },
  {
    text: "L'educazione è l'arma più potente che puoi usare per cambiare il mondo.",
    author: "Nelson Mandela"
  },
  {
    text: "Il tuo tempo è limitato, quindi non sprecarlo vivendo la vita di qualcun altro.",
    author: "Steve Jobs"
  },
  {
    text: "L'ispirazione esiste, ma deve trovarti al lavoro.",
    author: "Pablo Picasso"
  },
  {
    text: "Nel mezzo della difficoltà risiede l'opportunità.",
    author: "Albert Einstein"
  },
  {
    text: "Il successo è andare di fallimento in fallimento senza perdere l'entusiasmo.",
    author: "Winston Churchill"
  },
  {
    text: "La felicità non è qualcosa di già fatto. Viene dalle tue azioni.",
    author: "Dalai Lama"
  },
  {
    text: "La vita è per il 10% quello che ti succede e per il 90% come reagisci.",
    author: "Charles R. Swindoll"
  },
  {
    text: "Il momento migliore per piantare un albero era 20 anni fa. Il secondo momento migliore è adesso.",
    author: "Proverbio cinese"
  },
  {
    text: "Non sopravvive il più forte, né il più intelligente, ma quello che si adatta meglio al cambiamento.",
    author: "Charles Darwin"
  },
  {
    text: "La differenza tra l'ordinario e lo straordinario è quel piccolo extra.",
    author: "Jimmy Johnson"
  },
  {
    text: "Il fallimento è semplicemente l'opportunità di ricominciare, questa volta più intelligentemente.",
    author: "Henry Ford"
  },
  {
    text: "I limiti, come la paura, sono spesso solo un'illusione.",
    author: "Michael Jordan"
  },
  {
    text: "L'immaginazione è più importante della conoscenza.",
    author: "Albert Einstein"
  },
  {
    text: "Vivere è la cosa più rara al mondo. La maggior parte delle persone esiste solamente.",
    author: "Oscar Wilde"
  },
  {
    text: "Non aspettare il momento perfetto, prendi il momento e rendilo perfetto.",
    author: "Proverbio"
  },
  {
    text: "Non puoi esaurire la creatività. Più la usi, più ne hai.",
    author: "Maya Angelou"
  },
  {
    text: "Quello che non ti uccide ti rende più forte.",
    author: "Friedrich Nietzsche"
  }
]